import classes from "../../../../scss/SolutionsList.module.scss";
import { v4 as uuid } from "uuid";

export default function SolutionsList({ list }) {
  return (
    <ul className={classes.list}>
      {list.map((item) => {
        return (
          <li key={uuid()} className={classes.list__item}>
            <div className={classes.list__image}>
              <img src={item.icon} alt={item.title} />
            </div>
            <h3 className={classes.list__title}>{item.title}</h3>
            <p className={classes.list__text}>{item.text}</p>
          </li>
        );
      })}
    </ul>
  );
}
